import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { Button, Loader, Table, Modal, Alert } from '@itds/elements/index.js';

import Api from '@brokerage/utils/Api';

const MobileDevices = ({ member }) => {
  const [loading, setLoading] = useState(true);
  const [mobile_devices, setMobileDevices] = useState([]);
  const [mobile_apps, setMobileApps] = useState([]);
  const [success_message, setSuccessMessage] = useState();
  const [error_message, setErrorMessage] = useState();
  const [modal, setModal] = useState(null);
  const [action, setAction] = useState(null);

  useEffect(() => {
    loadMobileDevices();

    Api.loadMobileApps().then(({ data }) => {
      setMobileApps(data);
    });
  }, []);

  const loadMobileDevices = () => {
    setLoading(true);

    Api.loadMobileDevices({ member_id: member.id }).then(({ data }) => {
      setMobileDevices(data);
      setLoading(false);
    });
  };

  const handleDelete = (device, e) => {
    setModal('delete');
    setAction(device);
    e.stopPropagation();
  };

  const confirmDelete = () => {
    setLoading(true);
    window.scrollTo(0, 0);

    Api.deleteMobileDevice(action.id)
      .then(() => {
        setModal(null);
        setAction(null);
        loadMobileDevices();
        setSuccessMessage('Mobile Device deleted');
        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
      })
      .catch(() => {
        setModal(null);
        setAction(null);
        setErrorMessage('Unable to delete the Mobile Device at this time');
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };

  // const deleteMobileDevice = device => {

  //   // Api.deleteMobileDevice(device.id).then(() => {
  //   //   loadMobileDevices();
  //   // });
  // };

  return loading ? (
    <Loader />
  ) : (
    <div>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      <Table
        columns={[
          {
            id: 'device_type_name',
            label: 'Device Name'
          },
          {
            id: 'device_type_platform',
            label: 'Platform'
          },
          {
            id: 'device_type_version',
            label: 'Version'
          },
          {
            id: 'created_at',
            label: 'Created On',
            render: device => format(new Date(device.created_at), 'M/d/yyyy @ h:mm aaa')
          },
          {
            id: 'mobile_app_id',
            label: 'Mobile App ID',
            render: device => {
              const mobile_app = mobile_apps.find(m => m.id === device.mobile_app_id);

              return mobile_app ? mobile_app.name : 'N/A';
            }
          },
          {
            id: 'actions',
            label: '',
            styles: { textAlign: 'right', width: 100 },
            render: device => {
              return (
                <Button color='RED' onClick={handleDelete.bind(null, device)} small={true}>
                  Delete
                </Button>
              );
            }
          }
        ]}
        data={mobile_devices}
      />
      {modal === 'delete' ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
            setAction(null);
          }}
          title={`Delete "${action.device_type_name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete device "{action.device_type_name}"?
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

MobileDevices.propTypes = {
  member: PropTypes.object
};

export default MobileDevices;
